export const SECTIONS = {
    PARTIES_DOCUMENTS: { name: "PARTIES_DOCUMENTS", isMultiple: false, isRisk: false },
}